import { Injectable } from '@angular/core';

declare const gapi: any;

@Injectable({
  providedIn: 'root'
})
export class GapiService {
  constructor() {
  }

  parseJwt(token: any) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }

  loadGapi() {
    
    return new Promise((resolve, reject) => {
      gapi.load('client', () => {
        gapi.client.init({ 'clientId': '226015714415-lg7hkqti2helefkhmq68v3a20uhqv7kf.apps.googleusercontent.com' }).then(() => {
          var userToken = localStorage.getItem("ut")

          if (userToken != null) {
            var parsedJwt = this.parseJwt(userToken);

            gapi.client.setToken({ access_token: parsedJwt.AccessToken });

          }

          resolve(gapi.client);
        })
      });
    });
  }

  getSites() {
    return gapi.client.request({
      'path': 'https://www.googleapis.com/webmasters/v3/sites'
    });
  }

  getSitemaps(siteUrl: string) {
    return gapi.client.request({
      'path': 'https://www.googleapis.com/webmasters/v3/sites/' + encodeURIComponent(siteUrl) + '/sitemaps'
    });
  }

  batchIndexUrls(urls: any) {
    const batch = gapi.client.newBatch();

    for (var i = 0; i < urls.length; i++) {
      batch.add(gapi.client.request({
        'path': 'https://indexing.googleapis.com/v3/urlNotifications:publish',
        'method': 'POST',
        'body': { url: urls[i], type: "URL_UPDATED" }
      }));
    }

    return batch;
  }

  batchInspectUrls(siteUrl: any, inspectionUrls: any) {
    const batch = gapi.client.newBatch();

    for (var i = 0; i < inspectionUrls.length; i++) {
      batch.add(gapi.client.request({
        'path': 'https://searchconsole.googleapis.com/v1/urlInspection/index:inspect',
        'method': 'POST',
        'body': { inspectionUrl: inspectionUrls[i], siteUrl: siteUrl }
      }), { 'id': inspectionUrls[i] });
    }

    return batch;
  }
}
